import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=c84a4618&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=c84a4618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84a4618",
  null
  
)

export default component.exports